import { ELocalStorageKey } from '../EGerdauService/types';
import { BreadcrumbItemProps } from '@gerdau/hefesto-mais-web/Breadcrumbs/Breadcrumbs.types';

interface UrlProps {
  url: 'catalog' | 'search-items' | 'spreadsheet-upload' | 'repeat-order';
  name: string;
}

export const getValueCookie = (key: string): string | undefined => {
  const cookiesList = String(document.cookie).split(';');
  const cookieKey = key + '=';
  for (const cookie of cookiesList) {
    if (cookie.substring(0, cookie.indexOf('=')).trim() === key) {
      return decodeURIComponent(
        cookie.trim().substring(cookieKey.length, cookie.length)
      );
    }
  }
};

export const setCookieWithExpiry = ({
  name,
  value,
  hours
}: {
  name: string;
  value: string | number | boolean;
  hours: number;
}) => {
  const now = new Date();
  now.setTime(now.getTime() + hours * 60 * 60 * 1000);
  const expires = 'expires=' + now.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
};

export function parseNumber(value = '1') {
  let numberClear = value.replace(/\./g, '');
  numberClear = numberClear.replace(/,/g, '.');
  return Number(numberClear);
}

export function deleteCookie(cookie = '') {
  const paths = [
    '/',
    '/purchase/commerce',
    '/purchase/long-steel/commerce/shopping-cart',
    '/purchase/long-steel/commerce/repeat-order',
    '/purchase/long-steel/commerce/spreadsheet-upload',
    '/purchase/long-steel/commerce/search-items',
    '/purchase/long-steel/steel-type-choose',
    '/purchase/long-steel/commerce',
    '/purchase/long-steel/catalog',
    '/purchase/long-steel',
    '/purchase'
  ];
  paths.forEach((path) => {
    document.cookie = `${cookie}=; expires=${new Date(
      0
    ).toUTCString()}; path=${path}`;
  });
}

export function purchaseOrigin() {
  const menuLinksCache = localStorage.getItem(
    ELocalStorageKey.LONG_STEEL_MENU_NAVEGATION
  );
  if (!menuLinksCache) {
    return '';
  }
  const convertedLinks = JSON.parse(
    menuLinksCache ?? ''
  ) as unknown as BreadcrumbItemProps[];

  const links = convertedLinks.filter(
    (link) => !['steel-type-choose', 'shopping-cart'].includes(link.url)
  )[0] as UrlProps;

  const dictionary = {
    catalog: 'vitrine',
    'search-items': 'comprar_selecionando_itens',
    'spreadsheet-upload': 'planilha',
    'repeat-order': 'historico'
  };

  return dictionary[links?.url] ?? '';
}
//códigos de pagamento antecipado boleto e deposito
export const paymentAnticipated = ['B010', 'B014'];
